import { BUTTON_CLICK_EVENT } from '@interhyp/api-tracking';
import { arrowDown, arrowLeft, arrowRight, arrowUp } from '@platform/icons';
import classNames from 'classnames';
import React from 'react';
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import { Spinner } from "../spinner/Spinner.js";
import styles from "./Button.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const validIconLeftVariants = new Set(['text', 'icon']);
export const validIconRightVariants = new Set(['text']);
export const noValidLoadingVariants = new Set(['text', 'icon']);
export const arrowIcons = new Set([arrowDown, arrowLeft, arrowRight, arrowUp]);
export const DEFAULT_ICON_SIZE = 24;
export const SMALL_ICON_SIZE = 16;
export const Button = /*#__PURE__*/React.forwardRef(({
  type = 'button',
  loading,
  secondary,
  process,
  small,
  fullWidth,
  noMinWidth,
  iconLeft,
  iconRight,
  className,
  children,
  trackingId,
  ...otherProps
}, ref) => {
  const {
    variant,
    tertiary,
    toolbar,
    onClick,
    ...rest
  } = otherProps;
  const isLoading = !noValidLoadingVariants.has(variant ?? '') && loading;
  const hasLeftIcon = validIconLeftVariants.has(variant ?? '') && !!iconLeft;
  const hasRightIcon = validIconRightVariants.has(variant ?? '') && !!iconRight && !hasLeftIcon;
  const classes = classNames(variant ? styles[variant] : styles.button, (secondary || toolbar) && !tertiary && styles.secondary, tertiary && styles.tertiary, process && styles.process, small && styles.small, noMinWidth || styles.minWidth, fullWidth && styles.fullWidth, isLoading && styles.loading, toolbar && styles.toolbar, className);
  let iconSize = small ? 'SMALL' : 'DEFAULT';

  // NOTE: for arrow icons ONLY use smaller size
  // decision from ux/ui
  if (hasRightIcon && arrowIcons.has(iconRight) || hasLeftIcon && arrowIcons.has(iconLeft)) {
    iconSize = 'SMALL';
  }
  const handleClickEvent = e => {
    BUTTON_CLICK_EVENT.track({
      trackingId: trackingId ?? ''
    });
    onClick?.(e);
  };
  return /*#__PURE__*/_jsxs("button", {
    ref: ref,
    type: type,
    className: classes,
    tabIndex: 0,
    onClick: handleClickEvent,
    ...rest,
    children: [hasLeftIcon && /*#__PURE__*/_jsx(LegacyIconRenderer, {
      icon: iconLeft,
      size: iconSize,
      className: styles.leftIcon
    }), /*#__PURE__*/_jsx("span", {
      children: children
    }), isLoading && /*#__PURE__*/_jsx("div", {
      className: styles.spinner,
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "currentColor"
      })
    }), hasRightIcon && /*#__PURE__*/_jsx(LegacyIconRenderer, {
      icon: iconRight,
      size: iconSize,
      className: styles.rightIcon
    })]
  });
});